import { isAxiosError } from 'axios';

import type { StripePortalDetailsPayload } from '@ctct/infrastructure-layer';
import { stripeAccountApi } from '@ctct/infrastructure-layer';

import { StripeCustomerDataSchema } from './schemas/customer.zod';
import { StripePortalDetailsSchema } from './schemas/portail-details.zod';
import { ScheduledDowngradeDataSchema } from './schemas/scheduled-downgrade.zod';
import { ScheduledDowngrade, StripeCustomer, StripePortalDetails } from '../../value-objects';
import { zodService } from '../ZodService';

class StripeAccountRepo {
  public async getStripeCustomer(): Promise<StripeCustomer> {
    const response = await stripeAccountApi.getStripeCustomer();
    const parsedData = zodService.safeParse(StripeCustomerDataSchema, response.data);

    return new StripeCustomer(parsedData);
  }

  public async getStripePortal(payload: StripePortalDetailsPayload): Promise<StripePortalDetails> {
    const response = await stripeAccountApi.getStripeCustomerPortalDetails(payload);

    const parsedData = zodService.safeParse(StripePortalDetailsSchema, response.data);

    return new StripePortalDetails(parsedData);
  }

  public async getHasScheduledDowngrade(): Promise<ScheduledDowngrade | null> {
    try {
      const response = await stripeAccountApi.getScheduledDowngrade();
      const parsedData = zodService.safeParse(ScheduledDowngradeDataSchema, response.data);

      return new ScheduledDowngrade(parsedData);
    } catch (error) {
      // 404 is expected when there is no scheduled downgrade
      // request to update endpoint was made to BE team, to make sure we don't get 404 error for most of the users on payload load
      if (isAxiosError(error) && error.response?.status === 404) {
        return null;
      }

      throw error;
    }
  }
}

export const stripeAccountRepo = new StripeAccountRepo();
